import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { InputUtils } from 'src/app/@core/utils/input-utils';
import { Order } from 'src/app/models/order';
import { Product } from 'src/app/models/product';
import { ProductCart } from 'src/app/models/product-cart';
import { Tax } from 'src/app/models/tax';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { GiftCardService } from 'src/app/services/giftcard.service';
import { ParamsService } from 'src/app/services/params.service';
import { ProductsService } from 'src/app/services/products.service';
import { TaxesService } from 'src/app/services/taxes.service';

@Component({
  selector: 'app-pos-add-giftcard-modal',
  templateUrl: './pos-add-giftcard-modal.component.html',
  styleUrls: ['./pos-add-giftcard-modal.component.sass']
})
export class PosAddGiftcardModalComponent implements OnInit {

  productCart: ProductCart = new ProductCart();
  productForm: FormGroup = new FormGroup({});
  product: Product = new Product();
  confirmAction: (product: ProductCart) => any = () => { };
  giftcardProductCode: string = "";
  order: Order = new Order();
  taxes: Array<Tax> = [];
  isEdit: boolean = false;
  constructor(private bsModalRef: BsModalRef, private formBuilder: FormBuilder, private paramsService: ParamsService, private giftcardService: GiftCardService, private readonly exceptionSolutionService: ExceptionSolutionService, private productService: ProductsService, private configService: ConfigurationService, private taxesService: TaxesService) {
    this.productForm = this.formBuilder.group({
      giftcardNumber: new FormControl("", [Validators.required, Validators.min(100000000000), Validators.max(999999999999)]),
      amount: new FormControl(undefined, [Validators.required, Validators.min(1)]),
    })
  }

  async ngOnInit(): Promise<void> {
    this.giftcardProductCode = (await this.paramsService.readParam("giftcard-product-code").toPromise()).response.value || "";
    this.product = (await this.productService.readProduct({ productCode: this.giftcardProductCode, branchCode: this.configService.readSelectedBranchAndSalesOrg().branch.code }).toPromise()).response;
    this.taxes = (await this.taxesService.readTaxes().toPromise()).response.content;
  }

  load() {
    this.productForm = this.formBuilder.group({
      giftcardNumber: new FormControl(this.productCart.serial, [Validators.required, Validators.min(1000000000000000), Validators.max(9999999999999999)]),
      amount: new FormControl(this.productCart.serial ? this.productCart.price : undefined, [Validators.required, Validators.min(1)]),
    });
  }
  async confirm() {
    const giftcards = (await this.giftcardService.readGiftCards({ page: 0, pageSize: 1, value: { number: this.productForm.value.giftcardNumber } }).toPromise()).response;

    if (giftcards.numberOfElements > 0) {
      this.exceptionSolutionService.showAlertWithSolution(`Facturación de Giftcards`, `Giftcard ${this.productForm.value.giftcardNumber} ya existe.`);
      return;
    }
    if (this.order.orderEntryList.some(s => s.serialNumber == this.productForm.value.giftcardNumber) && !this.isEdit) {
      this.exceptionSolutionService.showAlertWithSolution(`Facturación de Giftcards`, `Giftcard ${this.productForm.value.giftcardNumber} ya se agregó a la orden.`);
      return;
    }
    const tax = this.taxes.find(f => f.code == this.product.taxCode) ?? new Tax();
    this.productCart.productCode = this.product.code;
    this.productCart.description = this.product.description;
    this.productCart.serial = this.productForm.value.giftcardNumber;
    this.productCart.amount = 1;
    this.productCart.total = Number(this.productForm.value.amount ?? 0);
    this.productCart.price = Number(this.productForm.value.amount ?? 0);
    this.productCart.taxCode = tax.code;
    this.productCart.tax = tax.value;
    this.confirmAction(this.productCart)
    this.bsModalRef.hide();
  }
  cancel() {
    this.bsModalRef.hide();
  }

  onlyNumbers(event: any): boolean {

    return InputUtils.onlyNumbers(event);
  }

  onlyIntegerNumbers(event: any): boolean {
    return InputUtils.onlyNumbersWhole(event);
  }

}
